import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index/index.vue"),
  },
  {
    path: "/departments",
    name: "departments",
    component: () => import("@/pages/departments.vue"),
  },
  {
    path: "/department/:id",
    name: "departmentDetails",
    component: () => import("@/pages/departmentDetails.vue"),
  },
  {
    path: "/therapists",
    name: "theraphists",
    component: () => import("@/pages/theraphists.vue"),
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import("@/pages/special-pages/page-404.vue"),
  },
  {
    path: "/register/:mobile",
    name: "Registration",
    component: () => import("@/pages/register.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
